import * as grpcWeb from "@improbable-eng/grpc-web";

import { ProfileAcceptInvitationRequest, type ProfileAcceptInvitationReply } from "@aymeric_henry_sr/svelte-proto/profile_pb";
import { Profile, type ProfileAcceptInvitation } from "@aymeric_henry_sr/svelte-proto/profile_pb_service";

import { GRPC_HOST } from '../../constants/env.constants';
import { unaryTransport } from "../transport";
import { grpcError } from "$lib/utils/grpcError";

const { grpc } = grpcWeb;

export function acceptInvitation(invitationId: string) {
  return new Promise<{ status: grpc.Code, message: ProfileAcceptInvitationReply }>((resolve, reject) => {
    const req = new ProfileAcceptInvitationRequest()
    req.setInvitationid(invitationId)
    grpc.unary<ProfileAcceptInvitationRequest, ProfileAcceptInvitationReply, ProfileAcceptInvitation>(Profile.AcceptInvitation, {
      request: req,
      host: GRPC_HOST,
      transport: unaryTransport,
      onEnd: res => {
        const { status, statusMessage, message } = res;
        if (status === grpc.Code.OK && message !== null) { resolve({ status, message, }) }
        reject(grpcError("Accept invitation", arguments, res))
      },
    })
  })
}
